import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, adminOnly = false }) {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingClaims, setCheckingClaims] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (user) {
        const token = await user.getIdTokenResult();
        setIsAdmin(token.claims.admin || user.email === 'gowthamgateway@gmail.com'); // fallback
      }
      setCheckingClaims(false);
    };

    checkAdmin();
  }, [user]);

  if (loading || checkingClaims) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isAdmin) return <Navigate to="/" />;

  return children;
}
